import axios from 'axios';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/SuperAdminLogin.css';

const API_URL = process.env.REACT_APP_API_URL || 'window.location.origin/api';

function SuperAdminLogin() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      // Super admin usa el mismo endpoint de login, pero sin tenant_code
      const response = await axios.post(`${API_URL}/auth/login`, {
        username,
        password
      });

      // Guardar token y datos del super admin
      localStorage.setItem('super_admin_token', response.data.access_token);
      localStorage.setItem('super_admin', JSON.stringify(response.data.usuario));
      localStorage.setItem('is_super_admin', 'true');

      // Redirigir al dashboard de super admin
      navigate('/super-admin/dashboard');
    } catch (err) {
      console.error('Error completo:', err);
      console.error('Response:', err.response);
      const errorMessage = err.response?.data?.error || err.response?.data?.message || err.message || 'Error al iniciar sesión';
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="super-admin-login-container">
      <div className="super-admin-login-box">
        <div className="super-admin-header">
          <div className="super-admin-logo">
            <i className="fas fa-crown"></i>
          </div>
          <h1>Super Administrador</h1>
          <p>Panel de Gestión Multi-Tenant</p>
        </div>

        <form onSubmit={handleLogin} className="super-admin-form">
          {error && (
            <div className="alert alert-danger">
              <i className="fas fa-exclamation-circle"></i> {error}
            </div>
          )}

          <div className="form-group">
            <label>
              <i className="fas fa-user"></i> Usuario
            </label>
            <input
              type="text"
              className="form-control"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Ingrese su usuario"
              required
              autoFocus
            />
          </div>

          <div className="form-group">
            <label>
              <i className="fas fa-lock"></i> Contraseña
            </label>
            <input
              type="password"
              className="form-control"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Ingrese su contraseña"
              required
            />
          </div>

          <button
            type="submit"
            className="btn btn-super-admin btn-block"
            disabled={loading}
          >
            {loading ? (
              <>
                <i className="fas fa-spinner fa-spin"></i> Ingresando...
              </>
            ) : (
              <>
                <i className="fas fa-sign-in-alt"></i> Ingresar
              </>
            )}
          </button>
        </form>

        <div className="super-admin-footer">
          <p>
            <i className="fas fa-shield-alt"></i> Acceso restringido - Solo personal autorizado
          </p>
        </div>
      </div>
    </div>
  );
}

export default SuperAdminLogin;
